module.exports = __webpack_public_path__ + "static/product-l0970-jet-black-19fb0264ebec6a085b659967b635a6e9.png";